"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BradescoCheckNumberCalculator = void 0;
var BradescoCheckNumberCalculator = /** @class */ (function () {
    function BradescoCheckNumberCalculator() {
    }
    // Account validation
    BradescoCheckNumberCalculator.calculateAccount = function (accountNumber) {
        var numbers = accountNumber.split("");
        var sumSeq = 0;
        var sequence = 0;
        for (var i = 0; i < numbers.length; i++) {
            var n = parseInt(numbers[i]);
            sumSeq += this.multiplyAccordingWeight(n, i);
        }
        return this.accountModule(sumSeq);
    };
    BradescoCheckNumberCalculator.multiplyAccordingWeight = function (n, i) {
        var weight = [2, 7, 6, 5, 4, 3, 2];
        return n * weight[i];
    };
    BradescoCheckNumberCalculator.accountModule = function (sumSeq) {
        var module = sumSeq % 11;
        if (module === 0) {
            return "0";
        }
        else {
            if (module === 1) {
                return "P";
            }
            else {
                return (11 - module).toString();
            }
        }
    };
    // Agency validation
    BradescoCheckNumberCalculator.calculateAgency = function (agencyNumber) {
        var numbers = agencyNumber.split("");
        var sumSeq = 0;
        var sequence = 0;
        for (var i = 0; i < numbers.length; i++) {
            var seq = 5 - i;
            sumSeq += parseInt(numbers[i]) * seq;
        }
        return this.agencyModule(sumSeq);
    };
    BradescoCheckNumberCalculator.agencyModule = function (sumSeq) {
        var result = 11 - (sumSeq % 11);
        if (result === 10) {
            return "P";
        }
        else {
            if (result === 11) {
                return "0";
            }
            else {
                return result.toString();
            }
        }
    };
    return BradescoCheckNumberCalculator;
}());
exports.BradescoCheckNumberCalculator = BradescoCheckNumberCalculator;
//# sourceMappingURL=BradescoCheckNumberCalculator.js.map